import { createFileRoute } from '@tanstack/react-router';
import { AttendanceMap } from '@/modules/attendance/attendance-map';

export const Route = createFileRoute('/(dashboard)/_dashboard/attendance-map')({
  component: AttendanceMap,
});
